// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"998":"b8d77166","1488":"b8d77166","9845":"b8d77166"}[chunkId] + ".chunk.css";
};